<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="title-wrapper mb-4">
      <div>
        <h1 class="title-default">Transferências de produtos</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="cancelar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Selecione as unidades responsáveis pela movimentação dos itens.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <div class="row g-3">
          <div class="col-12 col-xl-6">
            <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
          </div>
          <div class="col-12 col-xl-6">
            <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
          </div>
        </div>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="200" width="100%" marginTop="24"></app-loading-box>
      </div>
    } @else {
      <!-- Origem e Destino -->
      <div class="section-container">
        <div class="row g-3">      
          
          <!-- Info: transferência entre empresas em breve -->
          <div class="mt-3">
            <app-alert-card type="info">
              A transferência entre empresas será implementada em breve. Por enquanto, só é possível transferir produtos entre locais de estoque da mesma empresa.
            </app-alert-card>
          </div>
          
          <!-- Origem -->
          <div class="col-12 col-md-6">
            <div class="origem-destino-label">
              <mat-icon class="label-icon">logout</mat-icon>
              <span class="label-text">Origem</span>
            </div>
            <p class="origem-destino-question">De qual loja os produtos vão sair?</p>

            <mat-form-field appearance="outline" class="w-100 mb-2" subscriptSizing="dynamic">
              <mat-label>Empresa</mat-label>
              <mat-select [value]="idEmpresaAtual" [disabled]="true">
                <mat-option [value]="idEmpresaAtual">{{ nomeEmpresaAtual }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Local origem</mat-label>
              <mat-select [(ngModel)]="idLocalizacaoEstoqueOrigem" [disabled]="isReadOnly" [required]="!isReadOnly">
                @for (l of localizacoes; track l.id) {
                  <mat-option [value]="l.id">{{ l.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Destino -->
          <div class="col-12 col-md-6">
            <div class="origem-destino-label">
              <mat-icon class="label-icon destino-icon">login</mat-icon>
              <span class="label-text">Destino</span>
            </div>
            <p class="origem-destino-question">Para qual loja enviar?</p>

            <mat-form-field appearance="outline" class="w-100 mb-2" subscriptSizing="dynamic">
              <mat-label>Empresa</mat-label>
              <mat-select [value]="idEmpresaAtual" [disabled]="true">
                <mat-option [value]="idEmpresaAtual">{{ nomeEmpresaAtual }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
              <mat-label>Local destino</mat-label>
              <mat-select [(ngModel)]="idLocalizacaoEstoqueDestino" [disabled]="isReadOnly" [required]="!isReadOnly">
                @for (l of localizacoes; track l.id) {
                  <mat-option [value]="l.id">{{ l.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>        

        <!-- Alert: mesma empresa = movimentação interna, sem NF-e -->
        @if (idEmpresaAtual) {
          <div class="mt-2">
            <app-alert-card type="info">
              Como a empresa de Origem e de Destino são a mesma, esta operação é tratada como uma movimentação interna entre locais de estoque. Não haverá emissão de Nota Fiscal de transferência.
            </app-alert-card>
          </div>
        }
      </div>

      <!-- Observações -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon>notes</mat-icon>
          <span>Observações</span>
        </div>
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Observações</mat-label>
          <textarea matInput [(ngModel)]="observacoes" rows="3" [disabled]="isReadOnly"></textarea>
        </mat-form-field>
      </div>

      <!-- Produtos -->
      <div class="section-container">
        <div class="section-title">
          <mat-icon>inventory_2</mat-icon>
          <span>Produtos</span>
        </div>

        @if (!isReadOnly || itens.length > 0) {
          <div class="produtos-toolbar">
            @if (itens.length > 0) {
              <mat-form-field appearance="outline" class="produtos-toolbar__filtro" subscriptSizing="dynamic">
                <mat-icon matPrefix>search</mat-icon>
                <mat-label>Filtrar produtos</mat-label>
                <input matInput [(ngModel)]="filtroProduto" placeholder="Buscar por nome ou SKU..." />
                @if (filtroProduto) {
                  <button matSuffix mat-icon-button (click)="filtroProduto = ''">
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            }
            @if (!isReadOnly) {
              <button mat-button class="btn-section" type="button" (click)="adicionarItem()">
                <mat-icon>add</mat-icon>
                Adicionar produto
              </button>
            }
          </div>
        }

        @if (!itens.length) {
          <app-empty-list
            title="Nenhum produto adicionado"
            subTitle="Clique em + Adicionar produto para começar">
          </app-empty-list>
        } @else {
          <div class="table-responsive desktop-view">
            <table mat-table [dataSource]="itensFiltrados" class="mat-elevation-z0 tabela-digitacao">

              <ng-container matColumnDef="produto">
                <th mat-header-cell *matHeaderCellDef>Produto</th>
                <td mat-cell *matCellDef="let item">
                  @if (isReadOnly) {
                    <span class="produto-nome">{{ item.descricaoProduto }}</span>
                  } @else {
                    <app-select-pesquisavel [control]="item.produtoControl" [apiUrl]="urlProduto"
                      [extraParams]="{ apenasControlaEstoque: true }"
                      [hideLabel]="true" placeholder="Produto"
                      idField="idProduto" nameField="descricao" [preloadedOptions]="item.produtoPreload"
                      (selectionChange)="onProdutoTrocado(item, $event)" [subscriptSizing]="'dynamic'">
                    </app-select-pesquisavel>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="sku">
                <th mat-header-cell *matHeaderCellDef>SKU</th>
                <td mat-cell *matCellDef="let item">{{ item.skuProduto || '—' }}</td>
              </ng-container>

              <ng-container matColumnDef="quantidade">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let item">
                  <div class="qtd-input-wrap">
                    @if (isReadOnly) {
                      <span>{{ item.quantidade | abnt:'quantidade' }}</span>
                    } @else {
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-qtd-inline">
                        <input matInput type="text" inputmode="decimal" [(ngModel)]="item.quantidade"
                               [currencyMask]="quantidadeMask"
                               (ngModelChange)="item.erroQtd = undefined" placeholder="0,00" />
                      </mat-form-field>
                    }
                    @if (!isReadOnly && (item.isLoteDetalhado || item.isSerieDetalhado)) {
                      <span class="rastreabilidade-wrap"
                            [matTooltip]="!idLocalizacaoEstoqueOrigem ? 'Selecione o local de origem primeiro' : (item.isLoteDetalhado ? 'Gerenciar lotes' : 'Gerenciar séries')">
                        <button mat-icon-button type="button" (click)="abrirRastreabilidade(item)"
                                [disabled]="!idLocalizacaoEstoqueOrigem">
                          <mat-icon class="material-symbols-outlined">{{ rastreabilidadeStatus(item) === 'ok' ? 'data_check' : 'data_alert' }}</mat-icon>
                        </button>
                        <span class="status-badge badge-rastreabilidade"
                              [class.badge-vermelho]="rastreabilidadeStatus(item) === 'vazio'"
                              [class.badge-amarelo]="rastreabilidadeStatus(item) === 'parcial'"
                              [class.badge-verde]="rastreabilidadeStatus(item) === 'ok'"
                              [matTooltip]="(item.isLoteDetalhado ? 'Lote' : 'Série') + ' informado: ' + (rastreabilidadeInformada(item) | abnt:'quantidade') + ' de ' + (item.quantidade | abnt:'quantidade') + ' necessário(s)'">
                          {{ rastreabilidadeInformada(item) | abnt:'quantidade' }} / {{ item.quantidade | abnt:'quantidade' }}
                        </span>
                      </span>
                    }
                  </div>
                  @if (item.erroQtd) {
                    <div class="item-erro-msg">{{ item.erroQtd }}</div>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="unidade">
                <th mat-header-cell *matHeaderCellDef>Unidade</th>
                <td mat-cell *matCellDef="let item">{{ item.unidade ?? 'UN' }}</td>
              </ng-container>

              <ng-container matColumnDef="estoqueOrigem">
                <th mat-header-cell *matHeaderCellDef>Estoque origem</th>
                <td mat-cell *matCellDef="let item">{{ item.estoqueOrigem ?? '—' }}</td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef class="col-acoes text-center">Ações</th>
                <td mat-cell *matCellDef="let item; let i = index" class="col-acoes">
                  @if (!isReadOnly) {
                    <button mat-icon-button class="btn-remover" type="button" (click)="removerItem(item)" matTooltip="Remover item">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <div class="mobile-view">
            @for (item of itensFiltradosMobile; track item; let i = $index) {
              <div class="item-card">
                <div class="item-card__header">
                  @if (isReadOnly) {
                    <strong>{{ item.descricaoProduto }}</strong>
                  } @else {
                    <app-select-pesquisavel class="item-card__produto" [control]="item.produtoControl" [apiUrl]="urlProduto" label="Produto"
                      [extraParams]="{ apenasControlaEstoque: true }"
                      idField="idProduto" nameField="descricao" [preloadedOptions]="item.produtoPreload"
                      (selectionChange)="onProdutoTrocado(item, $event)" [subscriptSizing]="'dynamic'">
                    </app-select-pesquisavel>
                    <div class="item-card__delete-col">
                      <button mat-icon-button class="btn-remover" type="button" (click)="removerItem(item)" matTooltip="Remover item">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                      </button>
                    </div>
                  }
                </div>
                <div class="item-card__body">
                  @if (item.skuProduto) { <span class="item-card__sku">SKU: {{ item.skuProduto }}</span> }
                  <div class="qtd-input-wrap">
                    @if (isReadOnly) {
                      <span>{{ item.quantidade | abnt:'quantidade' }}</span>
                    } @else {
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-qtd-card">
                        <mat-label>Quantidade</mat-label>
                        <input matInput type="text" inputmode="decimal" [(ngModel)]="item.quantidade"
                               [currencyMask]="quantidadeMask"
                               (ngModelChange)="item.erroQtd = undefined" placeholder="0,00" />
                      </mat-form-field>
                    }
                    @if (!isReadOnly && (item.isLoteDetalhado || item.isSerieDetalhado)) {
                      <span class="rastreabilidade-wrap"
                            [matTooltip]="!idLocalizacaoEstoqueOrigem ? 'Selecione o local de origem primeiro' : (item.isLoteDetalhado ? 'Gerenciar lotes' : 'Gerenciar séries')">
                        <button mat-icon-button type="button" (click)="abrirRastreabilidade(item)" [disabled]="!idLocalizacaoEstoqueOrigem">
                          <mat-icon class="material-symbols-outlined">{{ rastreabilidadeStatus(item) === 'ok' ? 'data_check' : 'data_alert' }}</mat-icon>
                        </button>
                        <span class="status-badge badge-rastreabilidade"
                              [class.badge-vermelho]="rastreabilidadeStatus(item) === 'vazio'"
                              [class.badge-amarelo]="rastreabilidadeStatus(item) === 'parcial'"
                              [class.badge-verde]="rastreabilidadeStatus(item) === 'ok'"
                              [matTooltip]="(item.isLoteDetalhado ? 'Lote' : 'Série') + ' informado: ' + (rastreabilidadeInformada(item) | abnt:'quantidade') + ' de ' + (item.quantidade | abnt:'quantidade') + ' necessário(s)'">
                          {{ rastreabilidadeInformada(item) | abnt:'quantidade' }} / {{ item.quantidade | abnt:'quantidade' }}
                        </span>
                      </span>
                    }
                  </div>
                  @if (item.erroQtd) {
                    <div class="item-erro-msg">{{ item.erroQtd }}</div>
                  }
                  <div class="item-card__grid">
                    <div>
                      <span class="item-card__label">Unidade</span>
                      <span>{{ item.unidade ?? 'UN' }}</span>
                    </div>
                    <div>
                      <span class="item-card__label">Estoque origem</span>
                      <span>{{ item.estoqueOrigem ?? '—' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<app-footer-action
  cancelarLabel="Cancelar"
  salvarLabel="Realizar transferência"
  [isLoadingSalvar]="isProcessando"
  [isSalvarDisabled]="isLoading || isReadOnly || isSaving || temErros"
  (cancelar)="cancelar()"
  (salvar)="realizarTransferencia()">
  @if (!isReadOnly) {
    <button mat-stroked-button class="btn-secondary" (click)="salvar()"
            [disabled]="isLoading || isSaving || isProcessando">
      @if (isSaving) { <mat-spinner diameter="20"></mat-spinner> }
      @else { <span>Salvar</span> }
    </button>
  }
</app-footer-action>
